import { render, staticRenderFns } from "./OptionItem.vue?vue&type=template&id=a9d0d880&"
import script from "./OptionItem.vue?vue&type=script&lang=ts&"
export * from "./OptionItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports